// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountDeletionController from "./account_deletion_controller"
application.register("account-deletion", AccountDeletionController)

import ActivityFiltersController from "./activity_filters_controller"
application.register("activity-filters", ActivityFiltersController)

import AdminFilterController from "./admin_filter_controller"
application.register("admin-filter", AdminFilterController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import BackupCodeVerificationController from "./backup_code_verification_controller"
application.register("backup-code-verification", BackupCodeVerificationController)

import BackupCodesController from "./backup_codes_controller"
application.register("backup-codes", BackupCodesController)

import BulkOperationsController from "./bulk_operations_controller"
application.register("bulk-operations", BulkOperationsController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClaimToggleController from "./claim_toggle_controller"
application.register("claim-toggle", ClaimToggleController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DashboardStatsController from "./dashboard_stats_controller"
application.register("dashboard-stats", DashboardStatsController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DeviceListFormController from "./device_list_form_controller"
application.register("device-list-form", DeviceListFormController)

import DeviceSearchFormController from "./device_search_form_controller"
application.register("device-search-form", DeviceSearchFormController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicOrganizationController from "./dynamic_organization_controller"
application.register("dynamic-organization", DynamicOrganizationController)

import EmailOtpSetupController from "./email_otp_setup_controller"
application.register("email-otp-setup", EmailOtpSetupController)

import EmailOtpVerificationController from "./email_otp_verification_controller"
application.register("email-otp-verification", EmailOtpVerificationController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import GsmaDeviceActionsController from "./gsma_device_actions_controller"
application.register("gsma-device-actions", GsmaDeviceActionsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImeiValidatorController from "./imei_validator_controller"
application.register("imei-validator", ImeiValidatorController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import KycPhoneValidationController from "./kyc_phone_validation_controller"
application.register("kyc-phone-validation", KycPhoneValidationController)

import Layout__LandingController from "./layout/landing_controller"
application.register("layout--landing", Layout__LandingController)

import MenuItemController from "./menu-item_controller"
application.register("menu-item", MenuItemController)

import MfaSetupController from "./mfa_setup_controller"
application.register("mfa-setup", MfaSetupController)

import MfaVerifyController from "./mfa_verify_controller"
application.register("mfa-verify", MfaVerifyController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MoveListController from "./move_list_controller"
application.register("move-list", MoveListController)

import MsisdnImeiLookupController from "./msisdn_imei_lookup_controller"
application.register("msisdn-imei-lookup", MsisdnImeiLookupController)

import MoveListModalController from "./move_list_modal_controller"
application.register("move-list-modal", MoveListModalController)

import MultiStepFormController from "./multi_step_form_controller"
application.register("multi-step-form", MultiStepFormController)

import MultistepFormController from "./multistep_form_controller"
application.register("multistep-form", MultistepFormController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OrganizationFormController from "./organization_form_controller"
application.register("organization-form", OrganizationFormController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import PhoneVerificationController from "./phone_verification_controller"
application.register("phone-verification", PhoneVerificationController)

import ProfileController from "./profile_controller"
application.register("profile", ProfileController)

import RetailerEditController from "./retailer_edit_controller"
application.register("retailer-edit", RetailerEditController)

import RolePermissionsController from "./role_permissions_controller"
application.register("role-permissions", RolePermissionsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SecurePageController from "./secure_page_controller"
application.register("secure-page", SecurePageController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import StepperController from "./stepper_controller"
application.register("stepper", StepperController)

import SubscriberListsController from "./subscriber_lists_controller"
application.register("subscriber-lists", SubscriberListsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleBoxController from "./toggle_box_controller"
application.register("toggle-box", ToggleBoxController)

import ToggleEditController from "./toggle_edit_controller"
application.register("toggle-edit", ToggleEditController)

import ToggleSwitchController from "./toggle_switch_controller"
application.register("toggle-switch", ToggleSwitchController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TotpVerificationController from "./totp_verification_controller"
application.register("totp-verification", TotpVerificationController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import TypeApprovalActionsController from "./type_approval_actions_controller"
application.register("type-approval-actions", TypeApprovalActionsController)

import TypeApprovalSelectorController from "./type_approval_selector_controller"
application.register("type-approval-selector", TypeApprovalSelectorController)

import TypeToggleController from "./type_toggle_controller"
application.register("type-toggle", TypeToggleController)

import UserIdentificationController from "./user_identification_controller"
application.register("user-identification", UserIdentificationController)

import UserTypeSelectionController from "./user_type_selection_controller"
application.register("user-type-selection", UserTypeSelectionController)
